import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type PublishSheetState = {
  open: boolean
  formToken: string | null
}

const initialState: PublishSheetState = {
  open: false,
  formToken: null,
}

const publishSheetSlice = createSlice({
  name: 'publishSheet',
  initialState,
  reducers: {
    openPublishSheet: (state, action: PayloadAction<{ formToken: string }>) => {
      state.open = true
      state.formToken = action.payload.formToken
    },
    closePublishSheet: state => {
      state.open = false
      state.formToken = null
    },
  },
})

export const { openPublishSheet, closePublishSheet } = publishSheetSlice.actions

export default publishSheetSlice.reducer
